// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3XfE5","file":"styles_file__2qf3F"};